module.exports = __webpack_public_path__ + "static/media/certificate-outline.8dd33c71.png";